import React, { Component } from 'react';

import Papa from 'papaparse';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const CATALOG_URL = 'https://s3.us-east-2.amazonaws.com/synapticgenes.bnd.edu.uy/catalogs/catalog.csv'


class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      catalog: undefined,
    };

    this.download()
  }

  download() {
    fetch(CATALOG_URL)
      .then(response => response.text())
      .then((csv) => {
        this.setState({
          catalog: Papa.parse(csv).data.slice(1).map(
            ([fbid, prob]) => ({ fbid, prob })
          )
        })
      })
      .catch((error) => {
        // handle your errors here
        console.error(error)
      })
  }

  render() {
    console.log(this.state.catalog)
    const columns = [
      {
        Header: 'FBID',
        accessor: 'fbid',
        Cell: props => (
          <a href={`http://flybase.org/reports/${props.value}.html`}>
            {props.value}
          </a>
        )
      },
      {
        Header: 'Probability',
        accessor: 'prob'
      }
    ]

    return (
      <div>
        <h1>
          Synaptic genes catalog
        </h1>
        <a href={CATALOG_URL}>
          Download CSV
        </a>
        <br /><br />
        {this.state.catalog &&
          <ReactTable
            data={this.state.catalog}
            columns={columns}
            pageSize={10}
          />
        }
      </div>
    );
  }
}

export default App;
